export enum SoundEffects {
  Applause,
  Headshake,
  PartyHorn,
  Frog,
}

export const soundEffectList = [
  { name: SoundEffects.Applause, url: "sounds/Applause.mp3" },
  { name: SoundEffects.Headshake, url: "sounds/Headshake.mp3" },
  { name: SoundEffects.PartyHorn, url: "sounds/PartyHorn.mp3" },
  { name: SoundEffects.Frog, url: "sounds/Frog.mp3" },
];
